/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AuthenticateRequest as DigiworkMaitreDDtoAuthenticationAuthenticateRequest } from '../../models/Digiwork/MaitreD/DTO/Authentication/authenticate-request';
import { PairDeviceResponseDto as DigiworkMaitreDDtoAuthenticationPairDeviceResponseDto } from '../../models/Digiwork/MaitreD/DTO/Authentication/pair-device-response-dto';

export interface PairDevice_1$Params {
      body?: DigiworkMaitreDDtoAuthenticationAuthenticateRequest
}

export function pairDevice_1(http: HttpClient, rootUrl: string, params?: PairDevice_1$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDDtoAuthenticationPairDeviceResponseDto>> {
  const rb = new RequestBuilder(rootUrl, pairDevice_1.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DigiworkMaitreDDtoAuthenticationPairDeviceResponseDto>;
    })
  );
}

pairDevice_1.PATH = '/api/mng/Venue/pairdevice';
